import { IViewDetailLineItem,IFeedingLineItemDetail, IShedLineItemDetail,
	     IFecalLineItemDetail, IGrowthLineItemDetail, IHealthLineItemDetail } from '../interfaces/';

export class ViewDetailLineItem implements IViewDetailLineItem {
	MasterDetailId: number;
	DetailTypeId: number;
    feedingLine: IFeedingLineItemDetail;
    shedLine: IShedLineItemDetail;
    fecalLine: IFecalLineItemDetail;
    growthLine: IGrowthLineItemDetail;
    healthLine: IHealthLineItemDetail;
    LineItemDate: Date;
}


// WEBPACK FOOTER //
// ./src/app/models/ViewDetailLineItem.ts